/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './lab-access.reducer';

export const LabAccessDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const labAccessEntity = useAppSelector(state => state.labAccess.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="labAccessDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.labAccess.detail.title">LabAccess</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.labAccess.id">Id</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.id}</dd>
          <dt>
            <span id="uhid">
              <Translate contentKey="tinyMedicRestApp.labAccess.uhid">Uhid</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.uhid}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.labAccess.active">Active</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="revoked">
              <Translate contentKey="tinyMedicRestApp.labAccess.revoked">Revoked</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.revoked ? 'true' : 'false'}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.labAccess.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.labAccess.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.labAccess.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.lastupdated}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.labAccess.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{labAccessEntity.cursor}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labAccess.comboUser">Combo User</Translate>
          </dt>
          <dd>{labAccessEntity.comboUser ? labAccessEntity.comboUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.labAccess.glucoUser">Gluco User</Translate>
          </dt>
          <dd>{labAccessEntity.glucoUser ? labAccessEntity.glucoUser.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/lab-access" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/lab-access/${labAccessEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default LabAccessDetail;
